import { render, staticRenderFns } from "./fccAviso.vue?vue&type=template&id=9bc554ae"
import script from "./fccAviso.vue?vue&type=script&lang=js"
export * from "./fccAviso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports